import type { I18nTranslations } from "@i18n/layouts"

export const ptTranslations: I18nTranslations = {
  sidebar: {
    dashboard: "Painel",
    inbox: "Caixa de entrada",
    ecommerce: "E-commerce",
    usersList: "Lista de usuários",
    profile: "Perfil",
    feed: "Feed",
    settings: "Configurações",
    pages: "Páginas",
    organizations: "Organizações",
    authentication: "Autenticação",
    docs: "Documentação",
    components: "Componentes",
    help: "Ajuda",
  },
  navbar: {
    toggleSidebar: "Alternar barra lateral",
    search: "Pesquisar",
    toggleTheme: "Alternar tema",
    notifications: "Notificações",
    settings: "Configurações",
    profile: "Perfil",
    logout: "Sair",
  },
}
